<template>
  <div class="rentpress-shortcode-floorplan-search-wrapper mb-5">
    <div :class="!sidebarFilters ? 'rentpress-floorplan-search-container' : ''">
      <div
        v-if="!hideFiltersOption"
        class="hidden-md-and-up ma-5 rentpress-floorplan-top-filters-button"
      >
        <v-btn block color="primary" @click="toggleFilters = !toggleFilters">
          <v-icon class="pr-4">{{ $vuetify.icons.values.tune }}</v-icon> Toggle
          Filters
        </v-btn>
      </div>
      <div
        v-if="!hideFiltersOption && !sidebarFilters && shouldUseTopFilters"
        class="rentpress-top-floorplan-search-filter-wrapper"
      >
        <div class="rentpress-top-floorplan-search-filters">
          <p class="secondary--text font-weight-bold">FILTER</p>
          <div>
            <div v-if="!this.options.requested_beds">
              <v-select
                solo
                clearable
                multiple
                chips
                label="Bedroom Count"
                :items="possibleBedrooms"
                v-model="selectedBedrooms"
                @change="updateParams"
              >
                <template v-slot:selection="{ attrs, item, selected }">
                  <v-tooltip bottom open-delay="350" color="rgba(0, 0, 0, 0.5)">
                    <template v-slot:activator="{ on, attrs: tooltipAttrs }">
                      <v-chip
                        v-bind="{ ...attrs, ...tooltipAttrs }"
                        v-on="on"
                        :input-value="selected"
                        class="rentpress-chip-remove-hover"
                        @click="
                          selectedBedrooms.splice(
                            selectedBedrooms.indexOf(item.value),
                            1
                          );
                          updateParams();
                        "
                      >
                        {{ item.text }}
                      </v-chip>
                    </template>
                    <span>Remove</span>
                  </v-tooltip>
                </template>
              </v-select>
            </div>
            <div v-if="priceRanges.length > 0 && !disablePrice">
              <v-select
                solo
                clearable
                label="Max Price"
                :items="priceRanges"
                v-model="selectedPrice"
                @change="updateParams"
              ></v-select>
            </div>
            <div>
              <v-menu v-model="dateDisplay" :close-on-content-click="true">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-select solo :label="fromDateDisplay" readonly></v-select>
                  </div>
                </template>
                <v-date-picker
                  v-model="dateSelectorValue"
                  @change="updateParams"
                  @input="dateDisplay = false"
                  color="secondary"
                  header-color="primary"
                  :min="minDate"
                  :max="maxDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      dateSelectorValue = null;
                      updateParams();
                    "
                  >
                    CLEAR
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>

            <div v-if="floorplanFeatureFilterValues.length > 0">
              <v-select
                solo
                clearable
                multiple
                chips
                label="Features"
                :items="floorplanFeatureFilterValues"
                v-model="selectedFeatures"
                @change="updateParams"
              >
                <template v-slot:selection="{ attrs, item, selected }">
                  <v-tooltip bottom open-delay="350" color="rgba(0, 0, 0, 0.5)">
                    <template v-slot:activator="{ on, attrs: tooltipAttrs }">
                      <v-chip
                        v-bind="{ ...attrs, ...tooltipAttrs }"
                        v-on="on"
                        :input-value="selected"
                        class="rentpress-chip-remove-hover"
                        @click="
                          selectedFeatures.splice(
                            selectedFeatures.indexOf(item),
                            1
                          );
                          updateParams();
                        "
                      >
                        {{ item }}
                      </v-chip>
                    </template>
                    <span>Remove</span>
                  </v-tooltip>
                </template>
              </v-select>
            </div>

            <div v-if="parentproperties.length > 1 && !hidecommunityfilter">
              <v-select
                solo
                clearable
                multiple
                chips
                label="Community"
                :items="possibleProperties"
                v-model="selectedProperties"
                @change="updateParams"
              >
                <template v-slot:selection="{ attrs, item, selected }">
                  <v-tooltip bottom open-delay="350" color="rgba(0, 0, 0, 0.5)">
                    <template v-slot:activator="{ on, attrs: tooltipAttrs }">
                      <v-chip
                        v-bind="{ ...attrs, ...tooltipAttrs }"
                        v-on="on"
                        :input-value="selected"
                        class="rentpress-chip-remove-hover"
                        @click="
                          selectedProperties.splice(
                            selectedProperties.indexOf(item.value),
                            1
                          );
                          updateParams();
                        "
                      >
                        {{ item.text }}
                      </v-chip>
                    </template>
                    <span>Remove</span>
                  </v-tooltip>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div class="rentpress-top-floorplan-search-filter-sort">
          <p class="secondary--text font-weight-bold">SORT</p>
          <div>
            <div>
              <v-select
                v-if="!disablePrice"
                solo
                label="Select Sort"
                :items="possibleSorts"
                v-model="selectedSort"
              ></v-select>
              <v-select
                v-else-if="disablePrice"
                solo
                label="Select Sort"
                :items="possibleSortsNoPrice"
                v-model="selectedSort"
              ></v-select>
            </div>
          </div>
        </div>
      </div>
      <div
        :class="
          sidebarFilters
            ? 'rentpress-floorplan-sidebar-search-container'
            : 'rentpress-floorplan-card-wrapper'
        "
      >
        <div
          v-if="
            !hideFiltersOption &&
              shouldShowFilters &&
              (sidebarFilters || !shouldUseTopFilters)
          "
          xl="4"
          lg="4"
          md="6"
          sm="12"
          cols="auto"
          background-color="#F9F9F9"
          class="rentpress-floorplan-sidebar"
        >
          <v-row
            no-gutters
            justify="center"
            class="rentpress-floorplan-search-filters"
          >
            <v-col
              cols="12"
              class="myFont font-weight-bold rentpress-browse-floorplans-input"
              v-if="engrainMapLink"
            >
              <v-btn
                class="rentpress-inherited-font-family"
                block
                large
                color="primary"
                @click="toggleMap = false"
                :outlined="toggleMap"
              >
                Browse Floor Plans
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              class="myFont font-weight-bold rentpress-browse-map-input"
              v-if="engrainMapLink"
            >
              <v-btn
                color="secondary"
                class="rentpress-inherited-font-family"
                block
                large
                @click="toggleMap = true"
                :outlined="!toggleMap"
              >
                Browse Apartment Map
              </v-btn>
            </v-col>
            <v-row justify="center">
              <v-col
                cols="12"
                class="myFont pb-0 text-overline font-weight-bold text-center secondary--text"
              >
                Sort
              </v-col>
              <v-col xl="10" lg="10" md="8" sm="12" cols="12">
                <v-select
                  solo
                  label="Select Sort"
                  :items="possibleSorts"
                  v-model="selectedSort"
                ></v-select>
                <v-divider :thickness="4" class="mb-4 mx-10"></v-divider>
              </v-col>
            </v-row>
            <v-col
              cols="12"
              class="myFont text-overline font-weight-bold text-center secondary--text"
              v-if="!this.options.requested_beds"
            >
              Bedrooms
            </v-col>
            <v-col
              xl="10"
              lg="10"
              md="8"
              sm="12"
              cols="12"
              v-if="!this.options.requested_beds"
            >
              <v-select
                solo
                clearable
                multiple
                chips
                label="Bedroom Count"
                :items="possibleBedrooms"
                v-model="selectedBedrooms"
                @change="updateParams"
              >
                <template v-slot:selection="{ attrs, item, selected }">
                  <v-tooltip bottom open-delay="350" color="rgba(0, 0, 0, 0.5)">
                    <template v-slot:activator="{ on, attrs: tooltipAttrs }">
                      <v-chip
                        v-bind="{ ...attrs, ...tooltipAttrs }"
                        v-on="on"
                        :input-value="selected"
                        class="rentpress-chip-remove-hover"
                        @click="
                          selectedBedrooms.splice(
                            selectedBedrooms.indexOf(item.value),
                            1
                          );
                          updateParams();
                        "
                      >
                        {{ item.text }}
                      </v-chip>
                    </template>
                    <span>Remove</span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>
            <v-col
              v-if="priceRanges.length > 0 && !disablePrice"
              cols="12"
              class="myFont text-overline font-weight-bold text-center secondary--text"
            >
              Max Price / Month
            </v-col>
            <v-col
              xl="10"
              lg="10"
              md="8"
              sm="12"
              cols="12"
              v-if="priceRanges.length > 0 && !disablePrice"
            >
              <v-select
                solo
                clearable
                label="Max Price"
                :items="priceRanges"
                v-model="selectedPrice"
                @change="updateParams"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              class="myFont text-overline font-weight-bold text-center secondary--text"
            >
              Move-in Date
            </v-col>
            <v-col xl="10" lg="10" md="8" sm="12" cols="12">
              <v-menu v-model="dateDisplay" :close-on-content-click="true">
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-select solo :label="fromDateDisplay" readonly></v-select>
                  </div>
                </template>
                <v-date-picker
                  v-model="dateSelectorValue"
                  @change="updateParams"
                  @input="dateDisplay = false"
                  color="secondary"
                  header-color="primary"
                  style="width: 100%"
                  :min="minDate"
                  :max="maxDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="
                      dateSelectorValue = null;
                      updateParams();
                    "
                  >
                    CLEAR
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col
              cols="12"
              class="myFont text-overline font-weight-bold text-center secondary--text"
              v-if="parentproperties.length > 1 && !hidecommunityfilter"
            >
              Community
            </v-col>
            <v-col
              v-if="parentproperties.length > 5 && !hidecommunityfilter"
              xl="10"
              lg="10"
              md="8"
              sm="12"
              cols="12"
            >
              <v-select
                solo
                clearable
                multiple
                chips
                label="Community"
                :items="possibleProperties"
                v-model="selectedProperties"
                @change="updateParams"
              >
                <template v-slot:selection="{ attrs, item, selected }">
                  <v-tooltip bottom open-delay="350" color="rgba(0, 0, 0, 0.5)">
                    <template v-slot:activator="{ on, attrs: tooltipAttrs }">
                      <v-chip
                        v-bind="{ ...attrs, ...tooltipAttrs }"
                        v-on="on"
                        :input-value="selected"
                        class="rentpress-chip-remove-hover"
                        @click="
                          selectedProperties.splice(
                            selectedProperties.indexOf(item.value),
                            1
                          );
                          updateParams();
                        "
                      >
                        {{ item.text }}
                      </v-chip>
                    </template>
                    <span>Remove</span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>

            <v-col
              v-else-if="parentproperties.length > 1 && !hidecommunityfilter"
              xl="10"
              lg="10"
              md="8"
              sm="12"
              cols="12"
            >
              <v-checkbox
                v-for="prop in parentproperties"
                :key="prop.property_code"
                :label="prop.property_name"
                :value="prop.property_code"
                v-model="selectedProperties"
                :color="
                  prop.property_use_accent_color === '1'
                    ? prop.property_accent_color
                    : ''
                "
              ></v-checkbox>
            </v-col>

            <v-col
              v-if="floorplanFeatureFilterValues.length > 0"
              cols="12"
              class="myFont text-overline font-weight-bold text-center secondary--text"
            >
              Features
            </v-col>
            <v-col
              xl="10"
              lg="10"
              md="8"
              sm="12"
              cols="12"
              v-if="floorplanFeatureFilterValues.length > 0"
            >
              <v-select
                solo
                clearable
                multiple
                chips
                label="Features"
                :items="floorplanFeatureFilterValues"
                v-model="selectedFeatures"
                @change="updateParams"
              >
                <template v-slot:selection="{ attrs, item, selected }">
                  <v-tooltip bottom open-delay="350" color="rgba(0, 0, 0, 0.5)">
                    <template v-slot:activator="{ on, attrs: tooltipAttrs }">
                      <v-chip
                        v-bind="{ ...attrs, ...tooltipAttrs }"
                        v-on="on"
                        :input-value="selected"
                        class="rentpress-chip-remove-hover"
                        @click="
                          selectedFeatures.splice(
                            selectedFeatures.indexOf(item),
                            1
                          );
                          updateParams();
                        "
                      >
                        {{ item }}
                      </v-chip>
                    </template>
                    <span>Remove</span>
                  </v-tooltip>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </div>
        <v-row
          justify="center"
          v-if="!toggleMap"
          :class="
            engrainMapLink && !sidebarFilters
              ? 'rentpress-floorplan-search-has-map'
              : ''
          "
        >
          <v-col
            :sm="engrainMapLink && !sidebarFilters ? 6 : 12"
            justify="center"
            v-if="filteredFloorplans.length > 0"
            class="rentpress-floorplan-card-container"
          >
            <div
              v-for="floorplan in filteredFloorplans"
              :key="floorplan.floorplan_code"
              v-resize="onResize"
              cols="auto"
              class="rentpress-remove-link-decoration rentpress-floorplan-card"
            >
              <a
                :href="useModals ? false : floorplan.floorplan_post_link"
                v-on:click="
                  selectThisFloorplan(floorplan);
                  gtag('event', 'floorplan_view_rentpress', {
                    property_name: floorplan.floorplan_parent_property_name,
                    floorplan_name: floorplan.floorplan_post_title
                  });
                "
              >
                <floorplan-card
                  :floorplan="floorplan"
                  :options="options"
                  :formatter="formatter"
                  :useModals="useModals"
                  :propColors="propertyColors"
                />
              </a>
            </div>
          </v-col>
          <v-col
            v-else
            class="mt-12 rentpress-search-shortcode-floorplan-search-no-floorplans-container"
          >
            <v-row justify="center" class="text-center">
              <v-col cols="auto">
                <p
                  class="
              rentpress-inherited-font-family
              primary--text
              text-h4
              font-weight-black
            "
                >
                  No Apartments Found
                </p>
                <p class="rentpress-inherited-font-family text-subtitle-1">
                  Try another search or
                  <a @click="navigateTo(contactLink)" class="primary--text"
                    >Contact Us</a
                  >
                  for more information.
                </p>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="6" v-if="engrainMapLink && !sidebarFilters">
            <sight-map
              :units="filteredFloorplanUnits"
              :options="options"
              :link="engrainMapLink"
              :floorplans="filteredFloorplans"
              :useModals="useModals"
              :in-floorplan-page="true"
            ></sight-map>
          </v-col>
        </v-row>
        <div
          v-if="toggleMap && engrainMapLink"
          class="rentpress-sightmap-container"
        >
          <sight-map
            :units="filteredFloorplanUnits"
            :options="options"
            :link="engrainMapLink"
            :floorplans="filteredFloorplans"
            :useModals="useModals"
            :in-floorplan-page="true"
          ></sight-map>
        </div>
      </div>
    </div>
    <v-dialog
      fullscreen
      transition="dialog-bottom-transition"
      scrollable
      v-model="dialog"
      min-height="95vh"
    >
      <v-card
        height="90vh"
        style="overflow-y: auto; overflow-x: none;"
        class="pt-8"
      >
        <v-btn
          color="#303030"
          fab
          dark
          small
          absolute
          top
          right
          @click="dialog = false"
          class="mt-6 mr-n3"
          elevation="10"
        >
          <v-icon>{{ $vuetify.icons.values.close }}</v-icon>
        </v-btn>
        <single-floorplan-page
          v-if="selectedFloorplan.floorplan_code"
          :floorplan="selectedFloorplan"
          :options="options"
          :similarFloorplans="[]"
          :formatter="formatter"
          :shortcode="options.rentpress_shortcode_atts"
          class="pt-8 px-3"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import singleFloorplanPage from "./single-floorplan-page.vue";
import floorplanCard from "./floorplan-card.vue";
import sightMap from "./sight-map.vue";

export default {
  name: "floorplan-search",
  data() {
    return {
      toggleFilters: false,
      toggleMap: false,
      windowHorizontalSize: 0,
      onlyShowBed: this.options.requested_beds,
      onlyAvailable: this.options.only_available,
      hasSpecial: this.options.has_special,
      onlyMaxPrice: this.options.max_price,
      onlyMinPrice: this.options.min_price,
      selectedFloorplan: {},
      selectedBedrooms: this.options.requested_beds
        ? this.options.requested_beds
        : [],
      selectedProperties: [],
      selectedPropertiesCheckbox: [],
      possibleBedrooms: [],
      possibleProperties: [],
      possiblePropertyNamesAndCodes: {},
      dateDisplay: false,
      dateSelectorValue: null,
      floorplanFeatureFilterValues: [],
      possibleSorts: [
        {
          text: "Availability",
          value: "AVAIL"
        },
        {
          text: "Rent: Low To High",
          value: "ARENT"
        },
        {
          text: "Rent: High To Low",
          value: "DRENT"
        },
        {
          text: "Sq. Ft.: Low To High",
          value: "ASQFT"
        },
        {
          text: "Sq. Ft.: High To Low",
          value: "DSQFT"
        },
        {
          text: "Name: A to Z",
          value: "FPSAZ"
        },
        {
          text: "Bedrooms",
          value: "BED"
        }
      ],
      possibleSortsNoPrice: [
        {
          text: "Availability",
          value: "AVAIL"
        },
        {
          text: "Sq. Ft.: Low To High",
          value: "ASQFT"
        },
        {
          text: "Sq. Ft.: High To Low",
          value: "DSQFT"
        },
        {
          text: "Name: A to Z",
          value: "FPSAZ"
        },
        {
          text: "Bedrooms",
          value: "BED"
        }
      ],
      selectedSort: "AVAIL",
      showModal: false,
      priceRanges: [],
      selectedPrice: "",
      selectedFeatures: [],
      dialog: false,
      disablePrice: this.options
        .rentpress_disable_pricing_section_disable_pricing,
      lastStateWasModal: false,
      originalPageTitle: ""
    };
  },
  props: {
    floorplans: Array,
    parentproperties: Array,
    options: Object,
    hidecommunityfilter: {
      type: Boolean,
      default: false
    },
    hideFiltersOption: {
      type: Boolean,
      default: false
    },
    sidebarFilters: {
      type: Boolean,
      default: false
    },
    useModals: {
      type: Boolean,
      default: false
    },
    formatter: Intl.NumberFormat,
    useEngrain: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    fromDateDisplay() {
      if (this.dateSelectorValue) {
        const dateParts = this.dateSelectorValue.split("-");
        const date = new Date(
          dateParts[0],
          parseInt(dateParts[1]) - 1,
          dateParts[2]
        );
        return date.toLocaleDateString("en-US", {
          weekday: "short",
          month: "short",
          day: "numeric"
        });
      }
      return "Move-In Date";
    },
    minDate() {
      const today = new Date();
      return today.toISOString().split("T")[0];
    },
    maxDate() {
      const today = new Date();
      let lookahead = 90; // Default
      if (
        this.options &&
        this.options.rentpress_unit_availability_section_lookahead
      ) {
        const parsed = parseInt(
          this.options.rentpress_unit_availability_section_lookahead
        );
        if (!isNaN(parsed)) {
          lookahead = parsed;
        }
      }
      today.setDate(today.getDate() + lookahead);
      return today.toISOString().split("T")[0];
    },
    shouldShowFilters() {
      return this.toggleFilters || this.windowHorizontalSize >= 960;
    },
    shouldUseTopFilters() {
      if (!this.sidebarFilters && this.windowHorizontalSize < 960) {
        return false;
      }
      return this.windowHorizontalSize >= 960;
    },
    filteredFloorplans() {
      var chosenDateObj = new Date();
      if (this.dateSelectorValue) {
        let dateArray = this.dateSelectorValue.split("-");
        chosenDateObj = new Date(
          dateArray[0],
          parseInt(dateArray[1]) - 1,
          parseInt(dateArray[2]) + 1
        );
      }
      var fps = this.floorplans.filter(floorplan => {
        if (
          this.selectedBedrooms.length > 0 &&
          !this.selectedBedrooms.includes(
            parseInt(floorplan.floorplan_bedrooms)
          )
        ) {
          return false;
        }

        if (this.selectedFeatures.length > 0) {
          if (floorplan.floorplan_features === null) {
            return false;
          }
          let floorplan_features = JSON.parse(floorplan.floorplan_features);
          let floorplan_features_filtered = this.selectedFeatures.some(ai =>
            floorplan_features.includes(ai)
          );
          if (!floorplan_features_filtered) {
            return false;
          }
        }

        if (
          this.selectedProperties.length > 0 &&
          !this.selectedProperties.includes(
            floorplan.floorplan_parent_property_code
          )
        ) {
          return false;
        }

        if (this.selectedPrice && this.selectedPrice != "") {
          let price = parseInt(this.selectedPrice.replace(/[^0-9]/g, ""));
          if (
            price < floorplan.floorplan_rent_type_selection_cost ||
            floorplan.floorplan_rent_type_selection_cost < 100
          ) {
            return false;
          }
        }

        if (this.dateSelectorValue) {
          if (floorplan.units.length == 0) {
            return false;
          }

          for (var i = floorplan.units.length - 1; i >= 0; i--) {
            var availableDate = new Date(floorplan.units[i].unit_ready_date);
            if (chosenDateObj > availableDate) {
              return true;
            }
          }
          return false;
        }

        if (this.onlyAvailable && floorplan.floorplan_available == 0) {
          return false;
        }

        if (this.hasSpecial && !floorplan.floorplan_specials_message) {
          return false;
        }

        if (this.onlyMaxPrice) {
          const rentCost = Number(floorplan.floorplan_rent_type_selection_cost);
          if (
            floorplan.floorplan_rent_type_selection_cost === null ||
            isNaN(rentCost) ||
            rentCost > Number(this.onlyMaxPrice)
          ) {
            return false;
          }
        }

        if (this.onlyMinPrice) {
          const rentCost = Number(floorplan.floorplan_rent_type_selection_cost);
          if (
            floorplan.floorplan_rent_type_selection_cost === null ||
            isNaN(rentCost) ||
            rentCost < Number(this.onlyMinPrice)
          ) {
            return false;
          }
        }

        return true;
      });
      if (this.selectedSort == "AVAIL") {
        fps.sort((a, b) => {
          if (a.floorplan_rent_type_selection_cost === null) return 1;
          if (b.floorplan_rent_type_selection_cost === null) return -1;
          return (
            parseInt(a.floorplan_rent_type_selection_cost) -
            parseInt(b.floorplan_rent_type_selection_cost)
          );
        });
        fps.sort((a, b) => {
          if (a.floorplan_units_available === null) return 1;
          if (b.floorplan_units_available === null) return -1;
          return (
            parseInt(b.floorplan_units_available) -
            parseInt(a.floorplan_units_available)
          );
        });
      }
      if (this.selectedSort == "ARENT") {
        fps.sort((a, b) => {
          if (a.floorplan_rent_type_selection_cost === null) return 1;
          if (b.floorplan_rent_type_selection_cost === null) return -1;
          return (
            parseInt(a.floorplan_rent_type_selection_cost) -
            parseInt(b.floorplan_rent_type_selection_cost)
          );
        });
      }
      if (this.selectedSort == "DRENT") {
        fps.sort((a, b) => {
          if (a.floorplan_rent_type_selection_cost === null) return 1;
          if (b.floorplan_rent_type_selection_cost === null) return -1;
          return (
            parseInt(b.floorplan_rent_type_selection_cost) -
            parseInt(a.floorplan_rent_type_selection_cost)
          );
        });
      }
      if (this.selectedSort == "ASQFT") {
        fps.sort((a, b) => {
          if (a.floorplan_sqft_min === null) return 1;
          if (b.floorplan_sqft_min === null) return -1;
          return (
            parseInt(a.floorplan_sqft_min) - parseInt(b.floorplan_sqft_min)
          );
        });
      }
      if (this.selectedSort == "DSQFT") {
        fps.sort((a, b) => {
          if (a.floorplan_sqft_min === null) return 1;
          if (b.floorplan_sqft_min === null) return -1;
          return (
            parseInt(b.floorplan_sqft_min) - parseInt(a.floorplan_sqft_min)
          );
        });
      }
      if (this.selectedSort == "BED") {
        fps.sort((a, b) => {
          if (a.floorplan_sqft_min === null) return 1;
          if (b.floorplan_sqft_min === null) return -1;
          return (
            parseInt(b.floorplan_sqft_min) - parseInt(a.floorplan_sqft_min)
          );
        });
        fps.sort((a, b) => {
          if (a.floorplan_bedrooms === null) return 1;
          if (b.floorplan_bedrooms === null) return -1;
          return (
            parseInt(b.floorplan_bedrooms) - parseInt(a.floorplan_bedrooms)
          );
        });
      }
      if (this.selectedSort === "FPSAZ") {
        fps.sort((a, b) =>
          a.floorplan_post_title.localeCompare(b.floorplan_post_title, "en", {
            numeric: true
          })
        );
      }

      let gaFilterObject = {};

      if (this.selectedBedrooms.length) {
        gaFilterObject.bedChoice = JSON.stringify(this.selectedBedrooms);
      }
      if (this.selectedProperties.length) {
        let propertyNames = [];
        for (let i = this.selectedProperties.length - 1; i >= 0; i--) {
          let selectedProperty = this.selectedProperties[i];
          if (
            !propertyNames.includes(
              this.possiblePropertyNamesAndCodes[selectedProperty]
            )
          ) {
            propertyNames.push(
              this.possiblePropertyNamesAndCodes[selectedProperty]
            );
          }
        }
        gaFilterObject.propertyChoice = JSON.stringify(propertyNames);
      }
      if (this.selectedPrice) {
        gaFilterObject.priceCeiling = JSON.stringify(this.selectedPrice);
      }
      if (this.dateSelectorValue) {
        gaFilterObject.dateChoice = this.dateSelectorValue;
      }
      if (
        this.selectedBedrooms.length ||
        this.selectedProperties.length ||
        this.selectedPrice ||
        this.dateSelectorValue
      ) {
        this.gtag("event", "floorplan_filter_rentpress", gaFilterObject);
      }

      return fps;
    },
    useEngrainMap() {
      var atts = this.options.rentpress_shortcode_atts;
      var codes = [];
      var ids = [];
      var toggles = [];
      for (const key in atts) {
        if (!isNaN(key)) {
          toggles.push(atts[key].toUpperCase());
        }
        if (key === "property_codes") {
          codes.push(...atts[key].split(","));
        }
        if (key === "property_post_ids") {
          ids.push(atts[key]);
        }
      }
      if (codes.length > 1) {
        return false;
      }
      if (ids.length > 1) {
        return false;
      }
      if (!toggles.includes("ENGRAIN") && !this.useEngrain) {
        return false;
      }
      return true;
    },
    engrainMapLink() {
      var link = "";
      if (this.useEngrainMap) {
        var codes = [];
        for (var i = this.floorplans.length - 1; i >= 0; i--) {
          var floorplan = this.floorplans[i];
          if (!codes.includes(floorplan.floorplan_parent_property_code)) {
            codes.push(floorplan.floorplan_parent_property_code);
          }
        }
        var engrainUrl = this.floorplans[0]
          .floorplan_parent_property_engrain_url;
        if (codes.length <= 1 && engrainUrl !== null) {
          if (typeof engrainUrl !== "undefined" ? engrainUrl : "") {
            link = engrainUrl ? engrainUrl : "";
          }
        }
      }
      return link;
    },
    filteredFloorplanUnits() {
      var filteredUnits = [];
      if (this.filteredFloorplans) {
        for (var i = this.filteredFloorplans.length - 1; i >= 0; i--) {
          filteredUnits.push(
            ...this.filteredFloorplans[i].units.map(a =>
              a.unit_name.substring(0, 1) === "0"
                ? a.unit_name.replace(/^0+/, "")
                : a.unit_name
            )
          );
        }
      }
      return filteredUnits;
    },
    propertyColors() {
      var propColorsArray = {};
      if (this.parentproperties) {
        for (var i = this.parentproperties.length - 1; i >= 0; i--) {
          var prop = this.parentproperties[i];
          if (
            typeof prop.property_accent_color !== "undefined" &&
            prop.property_use_accent_color === "1"
          ) {
            propColorsArray[prop.property_code] = prop.property_accent_color;
          } else {
            propColorsArray[
              prop.property_code
            ] = this.options.rentpress_accent_color_section_input;
          }
        }
      }
      return propColorsArray;
    }
  },
  methods: {
    onResize() {
      this.windowHorizontalSize = window.innerWidth;
    },
    selectThisFloorplan: function(selection) {
      if (this.useModals) {
        let floorplan = selection;

        if (this.parentproperties) {
          const parentProperty =
            this.parentproperties.find(
              p => p.property_code === selection.floorplan_parent_property_code
            ) || {};
          floorplan = { ...parentProperty, ...floorplan };
        }

        this.selectedFloorplan = floorplan;
        this.dialog = true;
        const propertyName =
          this.selectedFloorplan.floorplan_parent_property_name || "";
        const websiteName = this.options.site_name || "";
        document.title = `${this.selectedFloorplan.floorplan_post_title} - ${propertyName} - ${websiteName}`;

        // Add URL param when modal opens
        const url = new URL(window.location);
        url.searchParams.set("floorplan", selection.floorplan_code);
        url.searchParams.delete("unit_name");
        url.searchParams.delete("unit_code");
        window.history.pushState({}, "", url);
        this.lastStateWasModal = true;
      }
    },

    openFloorplanFromURL() {
      const params = new URLSearchParams(window.location.search);
      const fp = params.get("floorplan");
      if (!fp) return;

      const match =
        this.floorplans.find(a => a.floorplan_code === fp) ||
        this.floorplans.find(
          a => a.floorplan_post_title.toLowerCase() === fp.toLowerCase()
        );

      if (match && this.useModals) {
        let floorplan = match;

        if (this.parentproperties) {
          const parentProperty =
            this.parentproperties.find(
              p => p.property_code === match.floorplan_parent_property_code
            ) || {};
          floorplan = { ...parentProperty, ...floorplan };
        }

        this.selectedFloorplan = floorplan;
        this.dialog = true;
      }
    },
    navigateToPost: function(post_id) {
      window.location = "/?page_id=" + post_id;
    },
    updateParams() {
      const url = new URL(
        document.location.origin + document.location.pathname
      );
      if (this.selectedPrice) {
        url.searchParams.set(
          "price",
          this.selectedPrice.replace(/[^0-9]/g, "")
        );
      }
      if (this.selectedBedrooms) {
        this.selectedBedrooms.forEach(a =>
          url.searchParams.append("bedrooms", a)
        );
      }
      if (this.selectedProperties) {
        this.selectedProperties.forEach(a =>
          url.searchParams.append("community", a)
        );
      }
      if (this.dateSelectorValue) {
        url.searchParams.set("move_in_date", this.dateSelectorValue);
      }
      window.history.pushState({}, "", url);
    }
  },
  watch: {
    dialog: function(isOpen) {
      if (isOpen) {
        if (
          this.selectedFloorplan &&
          this.selectedFloorplan.floorplan_post_title
        ) {
          const propertyName =
            this.selectedFloorplan.floorplan_parent_property_name || "";
          const websiteName = this.options.site_name || "";
          document.title = `${this.selectedFloorplan.floorplan_post_title} - ${propertyName} - ${websiteName}`;
        }
        return;
      }
      if (!isOpen) {
        this.selectedFloorplan = {};

        // Remove URL param when modal closes
        const url = new URL(window.location);
        url.searchParams.delete("floorplan");
        url.searchParams.delete("unit_name");
        url.searchParams.delete("unit_code");
        window.history.pushState({}, "", url);
        this.lastStateWasModal = false;
        document.title = this.originalPageTitle;
      }
    }
  },
  mounted: function() {
    this.onResize();
    this.originalPageTitle = document.title;
    window.addEventListener("popstate", () => {
      if (this.dialog) {
        this.dialog = false;
      }
    });
    this.openFloorplanFromURL();
    let bed_types = [];
    let availablePrices = [];
    if (
      typeof this.options.rentpress_shortcode_atts?.features_filter !==
      "undefined"
    ) {
      let all_floorplan_features = [];
      let floorplan_filter_values = [];
      let features_filter = this.options.rentpress_shortcode_atts.features_filter
        .replaceAll("%%", " ")
        .split("|");
      for (let i = this.floorplans.length - 1; i >= 0; i--) {
        let features = this.floorplans[i].floorplan_features;
        if (features != null) {
          all_floorplan_features.push(...JSON.parse(features));
        }
      }
      all_floorplan_features = [...new Set(all_floorplan_features)];
      if (all_floorplan_features.length) {
        if (features_filter.includes("*")) {
          floorplan_filter_values = all_floorplan_features;
        } else {
          floorplan_filter_values = all_floorplan_features.filter(element =>
            features_filter
              .map(v => v.toLowerCase())
              .includes(element.toLowerCase())
          );
        }
      }
      this.floorplanFeatureFilterValues = floorplan_filter_values.length
        ? floorplan_filter_values.sort()
        : [];
    }

    for (let j = this.floorplans.length - 1; j >= 0; j--) {
      bed_types = [
        ...bed_types,
        parseInt(this.floorplans[j].floorplan_bedrooms)
      ];

      if (
        this.floorplans[j].floorplan_rent_type_selection_cost &&
        this.floorplans[j].floorplan_rent_type_selection_cost > 100
      ) {
        availablePrices = [
          ...availablePrices,
          parseInt(this.floorplans[j].floorplan_rent_type_selection_cost)
        ];
      }
    }

    if (availablePrices.length > 0) {
      var minimumPrice = Math.ceil(Math.min(...availablePrices) / 50) * 50;
      var maximumPrice = Math.floor(Math.max(...availablePrices) / 50) * 50;
      this.priceRanges = [this.formatter.format(minimumPrice)];
      while (minimumPrice < maximumPrice) {
        this.priceRanges.push(this.formatter.format((minimumPrice += 50)));
      }
    }

    // Set up possible bedrooms array
    let possibleBedroomsArray = bed_types
      .filter((item, pos) => bed_types.indexOf(item) === pos)
      .sort();

    possibleBedroomsArray.forEach(bedroomType => {
      let text = bedroomType == 0 ? "Studio" : bedroomType + " Bedroom";
      this.possibleBedrooms.push({
        text: text,
        value: bedroomType
      });
    });

    for (var m = this.parentproperties.length - 1; m >= 0; m--) {
      let prop = this.parentproperties[m];
      this.possibleProperties.push({
        text: prop.property_name,
        value: prop.property_code
      });
      this.possiblePropertyNamesAndCodes[prop.property_code] =
        prop.property_name;
    }

    this.selectedSort = this.options.default_sort;

    const urlParams = new URLSearchParams(window.location.search);
    urlParams
      .getAll("bedrooms")
      .forEach(a => this.selectedBedrooms.push(parseInt(a)));
    urlParams.getAll("community").forEach(a => this.selectedProperties.push(a));
    let price = urlParams.get("price");
    this.selectedPrice =
      price != null && Number.isInteger(Number(price))
        ? this.formatter.format(price)
        : "";
    this.dateSelectorValue = urlParams.get("move_in_date");
  },
  components: {
    singleFloorplanPage,
    floorplanCard,
    sightMap
  }
};
</script>

<style>
/* Setting padding to 0 prevents hiding last week of the month on mobile devices */
div.v-date-picker-table > table > tbody > tr > td {
  padding: 0 !important;
}

/* Top Filter Classes */
.rentpress-top-floorplan-search-filter-wrapper {
  display: flex;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  gap: 2em;
}

.rentpress-top-floorplan-search-filters {
  display: flex;
  flex-direction: column;
}

.rentpress-top-floorplan-search-filters > div {
  display: flex;
  flex-direction: row;
  gap: 2em;
}

.rentpress-top-floorplan-search-filters button,
.rentpress-floorplan-sidebar-search-container button {
  padding: 0;
  margin-left: 10px;
}

.rentpress-shortcode-wrapper .v-list-item__title {
  font-family: var(--user-font-fam);
}

/* Floorplan Card Grid (Shared for both sidebar and main grid) */
.rentpress-floorplan-search-container
  .rentpress-floorplan-card-wrapper
  .rentpress-floorplan-card-container,
.rentpress-floorplan-sidebar-search-container
  .rentpress-floorplan-card-container {
  display: grid;
  gap: 0.5em;
  grid-template-columns: 95vw;
  grid-template-rows: 1fr;
  justify-content: space-between;
}

@media (min-width: 600px) {
  .rentpress-floorplan-search-container
    .rentpress-floorplan-card-wrapper
    .rentpress-floorplan-card-container,
  .rentpress-floorplan-sidebar-search-container
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(2, 48%);
  }
  .rentpress-floorplan-search-container
    .rentpress-floorplan-search-has-map
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(1, 100%);
  }
  .rentpress-floorplan-sidebar-search-container
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(2, 48vw);
    justify-content: space-around;
  }
}

@media (min-width: 960px) {
  .rentpress-floorplan-search-container
    .rentpress-floorplan-card-wrapper
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(3, 33%);
  }
  .rentpress-floorplan-search-container
    .rentpress-floorplan-search-has-map
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(2, 50%);
  }
  .rentpress-floorplan-sidebar-search-container {
    display: grid;
    grid-template-columns:
      [page-start] min-content [sidebar] minmax(280px, 25vw)
      [floorplan-grid] 70vw [page-end] min-content;
    justify-content: space-around;
  }
  .rentpress-floorplan-sidebar-search-container .rentpress-floorplan-sidebar {
    grid-column: sidebar / floorplan-grid;
  }
  .rentpress-floorplan-sidebar-search-container
    .rentpress-floorplan-card-container {
    grid-column: floorplan-grid / page-end;
    grid-template-columns: repeat(2, 45%);
  }
}

@media (min-width: 1240px) {
  .rentpress-floorplan-sidebar-search-container {
    grid-template-columns: [page-start] 1em [sidebar] minmax(200px, 350px) [floorplan-grid] 71vw [page-end] 1em;
  }
  .rentpress-floorplan-sidebar-search-container
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(3, 32%);
  }
}

@media (min-width: 1500px) {
  .rentpress-floorplan-search-container
    .rentpress-floorplan-card-wrapper
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(4, 24%);
  }
}

@media (min-width: 1921px) {
  .rentpress-floorplan-search-container
    .rentpress-floorplan-card-wrapper
    .rentpress-floorplan-card-container,
  .rentpress-floorplan-sidebar-search-container
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(4, 24%);
  }
}

@media (min-width: 1921px) {
  .rentpress-floorplan-search-container
    .rentpress-floorplan-card-wrapper
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(5, 19%);
  }
  .rentpress-floorplan-sidebar-search-container
    .rentpress-floorplan-card-container {
    grid-template-columns: repeat(4, 24%);
  }
}

@media (max-width: 959px) {
  .rentpress-shortcode-floorplan-search-wrapper {
    overflow: none;
  }
}

@media (max-width: 960px) {
  .rentpress-floorplan-search-container {
    grid-template-columns: 95vw;
    grid-template-rows: auto auto auto;
    grid-template-areas: "top-filters-button" "top-filters" "floorplan-grid";
  }
  .rentpress-floorplan-search-container
    .rentpress-floorplan-top-filters-button {
    grid-area: top-filters-button;
  }
  .rentpress-floorplan-search-filters,
  .rentpress-floorplan-sidebar-search-container {
    max-width: 90vw !important;
    margin: auto;
  }
  /* Mobile-only flex layout for floorplan cards */
  .rentpress-floorplan-card-container {
    display: flex !important;
    flex-wrap: wrap;
    justify-content: center;
  }
  .rentpress-floorplan-card {
    flex: 1 1 100%;
    min-width: 250px;
    max-width: 90vw;
    margin: auto;
  }
}

@media (min-width: 600px) and (max-width: 959px) {
  .rentpress-floorplan-card {
    flex: 1 1 calc(50% - 1em);
    max-width: calc(50% - 1em);
  }
}

.rentpress-browse-floorplans-input {
  margin-bottom: 20px;
}

.rentpress-browse-floorplans-input,
.rentpress-browse-map-input {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

/* Chip hover effect for removal */
.rentpress-chip-remove-hover {
  cursor: pointer !important;
  transition: all 0.4s ease-in-out;
  border: 1px solid transparent !important; /* Prevent layout shift on hover */
}

.rentpress-chip-remove-hover:hover {
  background-color: #ffebee !important; /* Red 50 */
  color: #c62828 !important; /* Red 800 */
  border-color: #c62828 !important;
}
.rentpress-chip-remove-hover:hover .v-chip__content {
  color: #c62828 !important;
}

::v-deep .v-input__icon--clear .v-icon:hover {
  background-color: unset !important;
  color: red !important;
}

::v-deep .rentpress-shortcode-floorplan-search-wrapper .v-label {
  color: rgba(0, 0, 0, 0.6) !important;
}

/* Disable clicking on month/year in date picker header */
.v-date-picker-header__value {
  pointer-events: none;
}

.v-dialog .rentpress-cta-tour,
.v-dialog .rentpress-cta-info,
.v-dialog .rentpress-cta-apply,
.v-dialog .rentpress-cta-waitlist,
.v-dialog .rentpress-share-icon-email,
.v-dialog .rentpress-share-icon-sms,
.v-dialog .rentpress-share-icon-facebook,
.v-dialog .rentpress-share-icon-copy {
  box-shadow: none !important;
}
</style>
